import { usePvSection5 } from "./landing-pv-section5.hook";

export const PvSection5 = () => {
  const { t } = usePvSection5();

  return (
    <div className="pv-section5-container">
      <div className="font-12-roman">{t("landing_pv.section5.pretitle")}</div>
      <hr
        className="mt-3 mb-4"
        style={{ width: "40px", border: "1px solid white" }}
      />
      <div className="my-4 pv-section5-title">
        {t("landing_pv.section5.title")}
      </div>

      <div className="pv-section5-description ">
        {t("landing_pv.section5.description")}
      </div>
    </div>
  );
};
